<template>
  <div
    class="sidebar"
    :data-color="activeColor"
    :style="sidebarStyle"
  >
    <div class="logo">
      <router-link
        to="/reports"
        class="simple-text logo-mini"
      >
        <div class="logo-img">
          <img
            :src="imgLogo"
            alt="Logo Green 4T"
          >
        </div>
      </router-link>

      <a
        href="https://green4t.com.br/"
        target="_blank"
        class="simple-text logo-normal"
      >
        {{ title }}
      </a>
      <a
        class="logout-link"
        href="#"
        @click="logout"
      >
        Sair
      </a>
    </div>

    <div class="sidebar-wrapper">
      <slot name="content" />
      <md-list class="nav">
        <!--By default vue-router adds an active class to each route link. This way the links are colored when clicked-->
        <slot>
          <sidebar-link
            v-for="(link, index) in sidebarLinks"
            :key="link.name + index"
            :to="link.path"
            :link="link"
          />
        </slot>
      </md-list>
    </div>

    <div
      v-if="version"
      class="sidebar-footer"
    >
      <div class="version-label">
        Versão {{ version }}
      </div>
    </div>
  </div>
</template>

<script>
import SidebarLink from "./SidebarLink.vue";
import authService from "../../_services/auth.service";

export default {
  components: {
    SidebarLink,
  },
  props: {
    title: {
      type: String,
      default: "GREEN4T - PGI",
    },
    backgroundImage: {
      type: String,
      default: "/assets/green4t-wallpaper.webp",
    },
    imgLogo: {
      type: String,
      default: "/assets/logo_4t.png",
    },
    activeColor: {
      type: String,
      default: "",
      validator: value => {
        let acceptedValues = [ "", "purple", "blue", "green", "orange", "red" ];
        return acceptedValues.indexOf(value) !== -1;
      },
    },
    sidebarLinks: {
      type: Array,
      default: () => [],
    },
    autoClose: {
      type: Boolean,
      default: true,
    },
  },
  provide() {
    return {
      autoClose: this.autoClose,
    };
  },
  data() {
    return {
      version: process.env.VERSION,
    };
  },
  computed: {
    sidebarStyle() {
      return {
        backgroundImage: `url(${this.backgroundImage})`,
      };
    },
  },
  methods: {
    async logout(event) {
      event.preventDefault();
      event.stopPropagation();
      await authService.logout({ revokeToken: true });

      this.$router.push("/login");
    }
  }
};
</script>
<style scoped lang="scss">
@media screen and (min-width: 991px) {
  .nav-mobile-menu {
    display: none;
  }
}

.sidebar {
  display: flex;
  flex-direction: column;

  .sidebar-footer {
    padding-left: 30px;
    padding-bottom: 20px;
    color: #ffffff;
  }

  .logo-img img {
    width: 100%;
  }

  .logout-link {
    padding: 0.5em 1.25em;
  }
}
</style>
